// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3pmeM","question":"styles_question__3ox7E","description":"styles_description__2EpB5"};